export { default } from "./DetailBoard";
